import React, { Component } from 'react';

import {
  get as _get,
  map as _map,
  xorWith as _xorWith,
  isEqual as _isEqual,
  isFunction as _isFunction,
} from 'lodash';
import PropTypes from 'prop-types';

import StepStatuses from '../Utils/StepStatuses';

export default function withJSON(WrappedComponent) {
  return class extends Component {
    static propTypes = {
      stepsJSON: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          status: PropTypes.oneOf(Object.values(StepStatuses)),
        }),
      ),
      componentList: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]),
      ).isRequired,
      statuses: PropTypes.arrayOf(PropTypes.oneOf(Object.values(StepStatuses))),
      initialActiveSections: PropTypes.arrayOf(PropTypes.number).isRequired,
    };

    static defaultProps = {
      stepsJSON: [],
      statuses: [],
      componentList: {},
    };

    static getDerivedStateFromProps(props, state) {
      const formatedSteps = _map(props.stepsJSON, (step, index) => ({
        ...step,
        status: props.statuses[index] || step.status,
      }));

      const difference = _xorWith(formatedSteps, state.steps, _isEqual);

      if (difference.length > 0) {
        return { steps: formatedSteps };
      }

      return null;
    }

    constructor(props) {
      super(props);

      this.state = {
        steps: props.stepsJSON,
      };
    }

    setUpRef = wrappedComponent => {
      this.wrappedComponent = wrappedComponent;
    };

    startTimeLine = () => {
      if (_isFunction(this.wrappedComponent.startTimeLine)) {
        this.wrappedComponent.startTimeLine();
      }
    };

    retrieve = key => {
      return _get(this.props.componentList, key, () => null);
    };

    updateSteps = steps => {
      this.wrappedComponent?.updateSteps?.(steps);
    };

    renderStepBody = (step, index, isActive, steps) => {
      const DesiredComponent = this.retrieve(step.type);

      return (
        <DesiredComponent
          key={index}
          index={index}
          isActive={isActive}
          steps={steps}
          {...step}
          {...step.extraData}
        />
      );
    };

    render() {
      const { steps } = this.state;
      const { initialActiveSections, ...props } = this.props;

      return (
        <WrappedComponent
          ref={this.setUpRef}
          renderStepBody={this.renderStepBody}
          initialActiveSections={initialActiveSections}
          {...props}
          steps={steps}
        />
      );
    }
  };
}
